"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instagramAction = exports.InstagramButton = void 0;
var _icons = require("../../assets/icons");
var _sharing_helper = require("../../helpers/sharing_helper");
var _base = require("./base");
var instagramAction = exports.instagramAction = function instagramAction(_ref) {
  var shareUrl = _ref.shareUrl;
  (0, _sharing_helper.copyToClipboard)(shareUrl);
};
var InstagramButton = exports.InstagramButton = (0, _base.buildShareButtonComponent)({
  action: instagramAction,
  ariaLabel: 'Instagram',
  className: 'share-button--instagram',
  icon: _icons.InstagramIcon
});